/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    SaveCustomerTypeMapping,
    GetAllGroups,
    GetProductCategoties,
    GetProductDetailsByProductcatogeryID,
    GetCustomerOrderTypes,
    GetAllCustomerTypeMappingDetails,
    GetCustomerTypeDetaildByID,
    UpdateCustomerTypeMapping,
    DeleteCustomerTypeMapping,
    GetAllProductDetails,
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetCustomerOrderTypes() {
    const response = await CommonGet('/api/CustomerTypeMapping/GetCustomerOrderType', null);
    return response.data;
}

async function GetProductDetailsByProductcatogeryID(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductDetailsByProductcatogeryIDMultiSelect', '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetAllProductDetails() {
    const response = await CommonGet('/api/CustomerTypeMapping/GetAllProductDetails', null);
    return response.data;
}

async function GetAllCustomerTypeMappingDetails(values) {

    let model = {
        groupID: values.groupID,
        productCategoryID: values.productCategoryID,
        productID: values.productID,
        orderTypeID: values.orderTypeID ? parseInt(values.orderTypeID) : null
    }
    const response = await CommonPost('/api/CustomerTypeMapping/GetAllCustomerTypeMappingDetails', null, model);
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/MarketScreen/GetAllGroupsForMarketScreen', null);
    return response.data;
}
async function SaveCustomerTypeMapping(modelList) {
    const response = await CommonPost('/api/CustomerTypeMapping/SaveCustomerTypeMapping', null, modelList);
    return response;
}

async function GetCustomerTypeDetaildByID(customerTypeMappingID) {
    const response = await CommonGet('/api/CustomerTypeMapping/GetCustomerTypeDetaildByID', 'customerTypeMappingID=' + parseInt(customerTypeMappingID));
    return response.data;
}

async function UpdateCustomerTypeMapping(model) {
    const response = await CommonPost('/api/CustomerTypeMapping/UpdateCustomerTypeMapping', null, model);
    return response;
}

async function DeleteCustomerTypeMapping(customerTypeMappingID) {
    const id = parseInt(customerTypeMappingID);
    return await CommonGet('/api/CustomerTypeMapping/DeleteCustomerTypeMapping', 'customerTypeMappingID=' + id);

}


